import React, { FC } from 'react';

import EmptyStatePrompt from '@components/common/EmptyStatePrompt';
import ColorWrapper, { WithColor } from '@styles/colors';
import { SimpleOnPress } from '@interfaces/base';

interface ClearFiltersProps extends WithColor, SimpleOnPress {
  background?: string;
  text?: string;
  hideButton?: boolean;
}

const ClearFilters: FC<ClearFiltersProps> = ({ onPress, background, C, text = 'Something went wrong', hideButton = false }) => (
  <EmptyStatePrompt onPress={onPress} background={background} C={C} text={text} hideButton={hideButton} />
);

export default ColorWrapper(ClearFilters);
